import React, { useState, useEffect } from "react";
import { Form, Radio } from "antd";
import Typing from "../Typing/Typing";
import * as Utils from "../../services/utils";
import CmpsAnimation from "../CmpsAnimation/CmpsAnimation";
import Timestamp from "../../components/Timestamp/Timestamp";
import CmpsMsgStatus from "../CmpsMsgStatus/CmpsMsgStatus";
import CmpsNotValid from "../CmpsNotValid/CmpsNotValid";

function CmpsConsentFourth({ onComplete, onScroll, form, onShowInput }) {
    const [typing, setTyping] = useState(true);
    const [msg, setMsg] = useState(false);
    const [validConsent, setValidConsent] = useState(true);
    const [msgChoose, setMsgChoose] = useState(true);

    let list = [
        { label: "Acconsento", value: true },
        { label: "Non acconsento", value: false },
    ];

    const onChange = (e) => {
        if (form.getFieldValue("quarto_consenso").value) {
            setValidConsent(true);
            setMsgChoose(false);
            setMsg(form.getFieldValue("quarto_consenso").label);
            onComplete("step17");
        } else {
            setValidConsent(false);
        }
    };

    useEffect(() => {
        Utils.eventsDataLayer("customPageview", "/chatbot-fissa-appuntamento/privacy-step-4");
        onShowInput(false);
        const timer = setTimeout(() => {
            setTyping(false);
            onScroll();
        }, 2200);
        return () => clearTimeout(timer);
    }, []);

    return (
        <section id="cmps-consent4">
            {typing && <Typing wait={1200} />}
            {!typing && (
                <div className="messages messages--receiver">
                    <div className="message">
                        <CmpsAnimation wait={300} last={!msgChoose}>
                            <span className="bubble">
                                {/* Dichiari di aver scaricato e letto<br /> le INFORMATIVE, che i tuoi dati<br /> personali, ivi inclusi quelli<br /> particolari, siano trattati da<br /> Compass 
              Banca S.p.A. e<br /> comunicati a terzi (e da questi<br /> trattati), per le finalità ivi<br /> indicate alle lettere a) e d) e che<br /> Compass acquisisca dalle<br /> 
              Società del Gruppo Mediobanca,<br /> che quindi potranno<br /> trasmettere, i dati relativi<br /> all'andamento dei rapporti<br /> eventualmente intercorrenti con<br /> 
              queste ultime e li tratti per<br /> finalità strettamente connesse<br /> alla valutazione del merito<br /> creditizio della presente<br /> richiesta o per la 
              valutazione di<br /> un nuovo rapporto. */}
                                <b>
                                    Consenso al trattamento dei dati per la valutazione e gestione della richiesta anche mediante esecuzione dei dati dall'esercente e dalle società controllate da
                                    Compass e dalle società del Gruppo di appartenenza di Compass (lettere a e d)
                                </b>
                                <br />
                                <br />
                                Preso atto dell’Informativa resa da Compass Banca S.p.A. ai sensi degli artt. 13 e 14 del Regolamento e della normativa nazionale vigente in materia di protezione dei
                                dati personali e del Codice di condotta per i sistemi informativi gestiti da soggetti privati in tema di crediti al consumo, affidabilità e puntualità nei pagamenti,
                                <br />
                                <br />
                                i) che i tuoi dati personali particolari, ivi inclusi i dati biometrici, siano trattati da Compass e comunicati a terzi (e da questi trattati), per le finalità ivi
                                indicate alle lettere a) e d);
                                <br />
                                ii) che Compass acquisisca dalle società controllate e dalle società del Gruppo di appartenenza, che quindi potranno trasmettere, i dati relativi all’andamento dei
                                rapporti eventualmente intercorrenti con queste ultime e li tratti per finalità strettamente connesse alla valutazione del merito creditizio della presente richiesta o
                                per la valutazione di un nuovo rapporto;
                                <br />
                                iii) che Compass acquisisca, in caso di offerta dei propri servizi finanziari finalizzati all’acquisto di beni o servizi commercializzati a distanza, i tuoi dati
                                personali previamente forniti agli esercenti convenzionati sui propri siti e-commerce.
                            </span>
                        </CmpsAnimation>
                        {msgChoose && (
                            <CmpsAnimation wait={600} last={validConsent}>
                                <span className="bubble">Seleziona la tua scelta</span>
                            </CmpsAnimation>
                        )}
                        {!validConsent && <CmpsNotValid msg="Il consenso è obbligatorio per il prosieguo del processo" />}
                        <CmpsAnimation wait={900}>
                            {!msg && (
                                <Form.Item className={`cmps_radio_button cmps_radio_button__consent`} name="quarto_consenso">
                                    <Radio.Group onChange={onChange}>
                                        {list.map((item, index) => (
                                            <Radio.Button key={index} value={item}>
                                                {item.label}
                                            </Radio.Button>
                                        ))}
                                    </Radio.Group>
                                </Form.Item>
                            )}
                            <div className="info">
                                <span className="time">
                                    <Timestamp />
                                </span>
                            </div>
                        </CmpsAnimation>
                    </div>
                </div>
            )}
            {msg && (
                <div className="messages messages--sender">
                    <CmpsAnimation wait={300}>
                        <div className="message">
                            <span className="bubble">{msg}</span>
                        </div>
                        <div className="info">
                            <span className="time">
                                <Timestamp />
                            </span>
                            <CmpsMsgStatus />
                        </div>
                    </CmpsAnimation>
                </div>
            )}
        </section>
    );
}

export default CmpsConsentFourth;
